import {
	isArrayOfLength,
	isDate,
	isNumber
} from "@pheaa/channels-component-library";


export const normalizeDateTimeToEpoch = dateTime => {
	const normalizedDateTime = new Date(dateTime);
	return isDate(normalizedDateTime) ? normalizedDateTime.getTime() : null;
};

export const isInMaintenanceWindow = (maintSchedule, now = new Date().getTime()) => {
	let isInMaintWindow = false;

	if (isArrayOfLength(maintSchedule)) {

		const maintScheduleChecks = maintSchedule.map(maintWindow => {
			const { beginOn, endOn } = maintWindow;
			const normalizedBeginOn = normalizeDateTimeToEpoch(beginOn);
			const normalizedEndOn = normalizeDateTimeToEpoch(endOn);

			return isNumber(normalizedBeginOn) && isNumber(normalizedEndOn) && isNumber(now) && normalizedBeginOn < normalizedEndOn && normalizedBeginOn < now && normalizedEndOn > now;
		});

		maintScheduleChecks.includes(true) && (isInMaintWindow = true);
	}

	return isInMaintWindow;
};